import { Platform } from 'react-native';
import { Gesture } from 'react-native-gesture-handler';

// Polyfill for withTestId on web - it's not available in the web version of react-native-gesture-handler
if (Platform.OS === 'web') {
  // Store original gesture methods
  const gestureTypes = ['Pan', 'Tap', 'LongPress', 'Pinch', 'Rotation', 'Fling', 'Force', 'Manual', 'Simultaneous', 'Exclusive', 'Race'];
  
  gestureTypes.forEach((gestureType) => {
    const GestureType = (Gesture as any)[gestureType];
    if (GestureType && typeof GestureType === 'function') {
      // Wrap the gesture constructor to add withTestId support
      const OriginalGesture = GestureType;
      (Gesture as any)[gestureType] = function(...args: any[]) {
        const gesture = OriginalGesture.apply(this, args);
        
        // Add withTestId as a no-op function that returns the gesture itself (for chaining)
        if (!gesture.withTestId) {
          gesture.withTestId = function(testId: string) {
            // No-op on web, just return the gesture for chaining
            return this;
          };
        }
        
        return gesture;
      };
    }
  });
  
  // Also handle the case where gestures are created directly
  const originalPan = Gesture.Pan;
  if (originalPan) {
    Gesture.Pan = function(...args: any[]) {
      const gesture = originalPan.apply(this, args);
      if (!gesture.withTestId) {
        gesture.withTestId = function(testId: string) {
          return this;
        };
      }
      return gesture;
    } as any;
  }
}

